import React, { Component } from 'react'
import ReactTable from 'react-table'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import TrGroupComponent from './components/TrGroupComponent'
import TableRowComponent from './components/TableRowComponent'

import { LOCALE_PREFIX } from './constants'

import DeleteCell from './components/DeleteCell'
import DateCell from './components/DateCell'
import AddressCell from './components/AddressCell'
import TextCell from './components/TextCell'
import IconCell from './components/IconCell'

import './style.scss'

export default class TableContent extends Component {
    static propTypes = {
        activeGroupId: PropTypes.string.isRequired,
        deleteGroupMember: PropTypes.func.isRequired,
        loadGroupMembers: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
        members: PropTypes.array.isRequired,
        membersPerPage: PropTypes.number.isRequired,
        page: PropTypes.number.isRequired,
        pages: PropTypes.number.isRequired,
    }

    getColumns = () => [
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.type`} />,
            accessor: 'typeCd',
            resizable: false,
            width: 40,
            Cell: ({ value }) => <IconCell typeCd={value} />,
        },
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.ic`} />,
            accessor: 'regNbr',
            width: 170,
            resizable: false,
            Cell: (args) => {
                const {
                    original: { typeCd, regNbr, dateOfBirth },
                } = args
                return typeCd !== 'A0A101' ? (
                    <TextCell right margin={43} text={regNbr} />
                ) : (
                    <DateCell date={dateOfBirth} />
                )
            },
        },
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.name`} />,
            accessor: 'name',
            Cell: ({ value }) => <TextCell text={value} />,
        },
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.address`} />,
            Cell: (args) => {
                const {
                    original: { address },
                } = args
                // TODO Need change to ISO2 country on backend
                return <AddressCell address={address} country={'cz'} />
            },
        },
        {
            Header: () => <FormattedMessage id={`${LOCALE_PREFIX}.rowDt`} />,
            accessor: 'rowDt',
            width: 170,
            resizable: false,
            Cell: (args) => {
                const {
                    original: { rowDt, typeCd },
                } = args

                return typeCd !== 'A0A101' ? <DateCell date={rowDt} /> : null
            },
        },
        {
            // TODO: Need add data to resp on server
            // }, {
            //     Header: () => (<FormattedMessage id={`${LOCALE_PREFIX}.insertDate`} />),
            //     accessor: 'strtDt',
            //     Cell: ({ value }) => (<DateCell dateString={value} />),
            // }, {
            Cell: ({ value }) => (
                <DeleteCell
                    memberId={value}
                    groupId={this.props.activeGroupId}
                    onDeleteMember={this.props.deleteGroupMember}
                />
            ),
            resizable: false,
            accessor: 'entId',
            width: 25,
        },
    ]

    getRowProps = (state, row) => ({
        entity: _.get(row, 'original', null),
    })

    getTrProps = (state, row) => ({
        entity: _.get(row, 'original', null),
    })

    handleOnDeleteMember = (memberId) => () => {
        const { deleteGroupMember, activeGroupId } = this.props

        deleteGroupMember(activeGroupId, memberId)
    }

    handleOnPageChange = (nextPage) => {
        const { loadGroupMembers, activeGroupId } = this.props

        loadGroupMembers(activeGroupId, nextPage)
    }

    render() {
        const { members, loading, page, pages, membersPerPage } = this.props

        return (
            <div className="group-stack-table-content">
                <ReactTable
                    data={members}
                    columns={this.getColumns()}
                    showPagination
                    pageSize={membersPerPage}
                    pages={pages}
                    manual
                    page={page}
                    loading={loading}
                    filterable={false}
                    sortable={false}
                    onPageChange={this.handleOnPageChange}
                    TrGroupComponent={TrGroupComponent}
                    TrComponent={TableRowComponent}
                    getTrGroupProps={this.getRowProps}
                    getTrProps={this.getTrProps}
                    previousText={<FormattedMessage id={'global.previous'} />}
                    nextText={<FormattedMessage id={'global.next'} />}
                    pageText={<FormattedMessage id={'global.page'} />}
                    ofText={<FormattedMessage id={'global.of'} />}
                    loadingText={<FormattedMessage id={'global.loading'} />}
                    noDataText={<FormattedMessage id={'global.loading'} />}
                />
            </div>
        )
    }
}
